/* eslint-disable camelcase */
import React from 'react'

import locale from 'live/init/global-locale'
import LiveAPI from 'live/lib/api'
import i18n from 'live/services/i18n'
import serviceLocator from 'live/services/service-locator'

import { basicInfoPresenter } from './AssetInfos/BasicInfo'
import { AssetsTypeConfigurationWrapper } from './AssetTypeConfiguration'
import en_us from './i18n/en_us'
import pt_br from './i18n/pt_br'
import { ResourceGroupConfigurationWrapper } from './ResourceGroupConfiguration'
import { infoPresentersRegister } from './utils/api/InfoPresentersRegister'
import { hasAdminPermission, hasPermission } from './utils/permissions'

import '../shared'

const localeFiles = {
    pt_br: pt_br,
    en_us: en_us
}

// register current locale file
i18n.add(localeFiles[locale])

try {
    i18n.add(localeFiles[locale])
} catch (error) {
    console.log(error)
}

/** used to register Bowtie Settings on configuration Tab */
const AssetsManager = React.lazy(() =>
    import('./AssetsManager').then(module => ({ default: module.AssetsManagerWrapper }))
)

hasPermission &&
    serviceLocator.getService('live-ui:configuration-service').then(() => {
        LiveAPI.Extension.configuration.entries.register({
            group: i18n('Resources Manager'),
            area: 'resource_manager',
            component: AssetsManager,
            name: i18n('Resources Manager')
        })
    })

hasAdminPermission &&
    serviceLocator.getService('live-ui:configuration-service').then(() => {
        LiveAPI.Extension.configuration.entries.register({
            group: i18n('Resources Manager'),
            area: 'resource_manager_type',
            component: AssetsTypeConfigurationWrapper,
            name: i18n('Resource Types')
        })
    })

hasAdminPermission &&
    serviceLocator.getService('live-ui:configuration-service').then(() => {
        LiveAPI.Extension.configuration.entries.register({
            group: i18n('Resources Manager'),
            area: 'resource_manager_group',
            component: ResourceGroupConfigurationWrapper,
            name: i18n('Resource Groups')
        })
    })

infoPresentersRegister.addInfoPresenter(basicInfoPresenter)
